module.exports = __webpack_public_path__ + "img/foot_logo.49e717f9.png";